import React, { useMemo } from "react";
import PropTypes from "prop-types";

export const CostWithDiscount = React.memo(function CostWithDiscount({ cost, discountPercent }) {
  const normalizedCost = useMemo(() => {
    const asNumber = typeof cost === "string" ? parseFloat(cost) : cost;
    return Number.isFinite(asNumber) ? asNumber : null;
  }, [cost]);

  const normalizedDiscount = useMemo(() => {
    const asNumber = typeof discountPercent === "string" ? parseFloat(discountPercent) : discountPercent;
    if (!Number.isFinite(asNumber)) return 0;
    if (asNumber <= 0) return 0;
    return asNumber;
  }, [discountPercent]);

  if (normalizedCost === null) return null;

  if (!normalizedDiscount) return <>{normalizedCost}€</>;

  const discounted = ((1 - normalizedDiscount / 100) * normalizedCost).toFixed(2);
  return (
    <>
      <span style={{ textDecoration: "line-through" }}>{normalizedCost}€</span>
      <span className="ml-2">{discounted}</span>€
    </>
  );
});

CostWithDiscount.propTypes = {
  cost: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  discountPercent: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

